import { showErrorToast, showInfoToast } from "@/components/toster";

// src/utils/errorHandler.ts
let sessionExpiredToastShown = false;

export function resetSessionErrorFlag() {
    sessionExpiredToastShown = false;
}

export function handleApiError(error: any) {
    if (error?.message === "Session expired") {
        if (!sessionExpiredToastShown) {
            showInfoToast("Session expired. Please log in again.");
            sessionExpiredToastShown = true;
        }
    } else if (error?.message) {
        showErrorToast(error.message);
    } else {
        showErrorToast("Unexpected error occurred");
    }
}
